import { DashboardService } from '../../../../../service/events/dashboard.service';
import { AfterViewInit, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { environment } from '../../../../../../environments/environment';
import { MapaParcelasApiService } from '../../../../../service/api/mapa-parcelas-api.service';
import { VisitasVariedadMesApiService } from '../../../../../service/api/visitas_variedad_mes-api.service';
import { DialogSigPacComponent } from './dialog/dialog.sigpac.component';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { ParcelasFormDefinition } from './form-definition';
import { AnalisisApiService } from '../../../../../service/api/analisis-api.service';
import { configureParcelasDeclarativeDropdowns } from './parcelas-declarative-dropdowns.config';
import { ParcelasDropdownDataSourceFactory } from './parcelas-dropdown-datasource.factory';


import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ParcelasEnvironmentDefinition } from '../environment-variables';
import { HttpClient } from '@angular/common/http';
import { FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    ReactiveFormChangedField,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import { ParcelasCatalogHydrator } from './parcelas-catalog-hydrator';
import { ParcelasStableFormChangeAdapter } from './parcelas-stable-form-change.adapter';
import { ParcelasReaReviewAdapter } from './parcelas-rea-review.adapter';
import { ParcelasFormDataLoader } from './parcelas-form-data-loader';
import { ParcelasFormFacade } from './parcelas-form.facade';
import {
    getDropdownSelectedArray,
    getDropdownSelectedSingle,
    setDropdownSelected,
    setDropdownSelectedFromArray,
} from '@fitogest/reactive-form-builder/utils';
import {
    type ParcelasVariedadVariosCreateRequest
} from './parcelas-variedad-varios.adapter';

@Component({
    selector: 'app-parcelas-form',
    standalone: false,
    templateUrl: './parcelas-form.component.html',
    styleUrls: ['./parcelas-form.component.scss']
})
export class ParcelasFormComponent extends BaseForm<ParcelasModel> implements AfterViewInit, OnInit {

    @ViewChild('sigpac', { read: DialogSigPacComponent, static: true }) sigpacDialog: DialogSigPacComponent | undefined;

    public form!: ParcelasFormDefinition;

    public formRequest = new ReactiveFormRequestCoordinator<ParcelasModel>;

    public loadingData = true;

    public override model: ParcelasModel = {
        activo: '1',
        turbo: '1',
        mapa: [{} as FullMapModel]
    } as ParcelasModel;

    public mapaAux = {} as FullMapModel;

    public variedadVariosCreated = false;

    public env: ParcelasEnvironmentDefinition = new ParcelasEnvironmentDefinition();



    public origin = 'parcelas-form';

    public viewNumeroMetros = false;

    public nombreTouched = false;

    public comunidadForm: FormGroup;

    private pendingReaReviewFincaId = '';
    private externalDropdownsLoaded = false;
    private parcelasFormFacade: ParcelasFormFacade | null = null;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public formApi: FormCommonApiService,
        public fincasApi: FincasApiService,
        public mapaParcelasApi: MapaParcelasApiService,
        public override dashboard: DashboardService,
        public visitasVariedadMesApi: VisitasVariedadMesApiService,
        private readonly ventasApi: VentasApiService,
        public siexApi: SiexApiService,
        public analisisApi: AnalisisApiService,
        public usuariosAPI: UsuariosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        private readonly zone: NgZone,
        private readonly http: HttpClient,
        private readonly formBuilder: FormBuilder,
        private readonly dropdownDataSourceFactory: ParcelasDropdownDataSourceFactory

    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi.parcelasPUT,
            fincasApi.parcelasPOST,
            'parcelas',
            'Editar ' + environment.features.parcelaName,
            'Crear ' + environment.features.parcelaName
        );
        this.comunidadForm = this.formBuilder.group({
            nombre: ['', [Validators.required, Validators.maxLength(100)]],
            id_usuario: [StorageManager.getUser().id],
            id_cliente: [StorageManager.getClient()?.id ?? ''],
        });
    }


    ngAfterViewInit(): void {
        if (this.externalDropdownsLoaded) {
            this.formBuilderRef?.finalizeExternalDropdowns();
            this.formBuilderRef?.refreshExternalDropdownMappings();
        }
    }

    ngOnInit(): void {
        this.fincasApi.parcelasPOST.reset();
        this.fincasApi.parcelasPUT.reset();

        const reaReviewState = ParcelasReaReviewAdapter.buildInitialState({
            queryParamMap: this.route.snapshot.queryParamMap,
        });
        this.pendingReaReviewFincaId = reaReviewState.pendingFincaId;

        if (reaReviewState.modelPatch !== null) {
            this.model = {
                ...this.model,
                ...reaReviewState.modelPatch,
                mapa: this.model.mapa ?? [{} as FullMapModel]
            } as ParcelasModel;
        }

        if (this.pendingReaReviewFincaId !== '') {
            this.model.id_finca = this.pendingReaReviewFincaId;
        }

        this.form = new ParcelasFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            this.sigpacDialog as DialogSigPacComponent,
            null
        );
        this.form.formFields.previousDataTransform = (previousData) => this.transformCatalogPreviousData(previousData);
        this.configureDeclarativeDropdownSources();
        this.initFormData().catch((error: unknown) => {
            console.error('Error loading parcel form data', error);
        });
        this.expandFormRequest();
        this.formRequest.executePhase(FormPhase.LOAD);
        this.softInit(this.getType());
        this.form.model = this.model;
    }

    public async afterSend(res: unknown): Promise<void> {
        await this.getParcelasFormFacade().afterSend({
            backendResponse: res,
            currentMap: this.form.model.mapa?.[0] as FullMapModel | null | undefined,
            env: this.env,
            userId: StorageManager.getUser().id,
            customMapColors: this.env.customMapColorsList,
            variedadVariosCreated: this.variedadVariosCreated,
            loadExistingMaps: () => this.mapaParcelasApi.mapaParcelasGET.toPromise() as Promise<
                readonly FullMapModel[] | null | undefined
            >,
            updateMap: (map) => this.mapaParcelasApi.mapaParcelasPUT.toPromise(map),
            createMap: (map) => this.mapaParcelasApi.mapaParcelasPOST.toPromise(map),
            setAuxMap: (map) => {
                this.mapaAux = map;
            },
            reloadPage: () => {
                window.location.reload();
            },
            goBack: () => {
                this.goBack();
            },
            logError: (message, error) => {
                console.error(message, error);
            },
        });
    }

    public getSigPac(event: object): void {
        this.getParcelasFormFacade().applySigpacReference({
            event,
            applyModelPatch: (patch) => {
                Object.assign(this.form.model, patch);
            },
            updateReactiveForm: () => {
                this.formBuilderRef.updateForm(this.form.model, false);
            },
        });
    }

    public reloadComponent(): void {
        this.getParcelasFormFacade().reloadComponent({
            closeMap: () => {
                this.form.mapaOpened = false;
            },
            reloadPage: () => {
                window.location.reload();
            },
        });
    }


    public stableValueChanges(event: ReactiveFormStableValueChange<ParcelasModel>): void {
        this.applyStableFormChange(event.value, event.changedField);
    }

    public formChanges(
        formModel: ReactiveFormValue<ParcelasModel>,
        lastChangedFieldName: ReactiveFormChangedField<ParcelasModel>,
    ): void {
        this.applyStableFormChange(formModel, lastChangedFieldName);
    }

    private applyStableFormChange(
        formModel: ReactiveFormValue<ParcelasModel>,
        lastChangedFieldName: ReactiveFormChangedField<ParcelasModel>,
    ): void {
        const result = ParcelasStableFormChangeAdapter.resolveChange({
            formModel,
            changedField: lastChangedFieldName,
            env: this.env,
            client: StorageManager.getClient(),
            resolveDropdownRawValue: (fieldName, value) => this.formBuilderRef?.resolveDropdownRawValue(fieldName, value) ?? null,
        });

        this.form.model = result.formModel;
        this.form.tag = result.tag;

        if (result.markNombreTouched) {
            this.nombreTouched = true;
        }
    }


    public get reaReviewNotice(): string {
        return ParcelasReaReviewAdapter.getNotice({
            queryParamMap: this.route.snapshot.queryParamMap,
            formModel: this.form?.model,
            fallbackModel: this.model,
        });
    }

    public getFromMapa(datos: string): void {
        this.zone.run(() => {
            const nombreControl = this.formBuilderRef.model.get('nombre');

            this.getParcelasFormFacade().applyIncomingMapData({
                rawData: datos,
                currentMap: this.form.model.mapa?.[0] ?? null,
                currentMaps: this.form.model.mapa ?? [],
                env: this.env,
                userId: StorageManager.getUser().id,
                shouldUpdateName: Boolean(nombreControl && (nombreControl.pristine || !nombreControl.value)),
                applyModelPatch: (patch) => {
                    Object.assign(this.form.model, patch);
                },
                setMaps: (maps) => {
                    this.form.model.mapa = [...maps];
                },
                setSuggestedName: (name) => {
                    this.form.model.nombre = name;
                },
                closeMap: () => {
                    this.form.mapaAbierto = false;
                },
                updateReactiveForm: () => {
                    this.formBuilderRef.updateForm(this.form.model, false);
                },
                markNombrePristine: () => {
                    this.formBuilderRef.model.get('nombre')?.markAsPristine();
                },
            });
        });
    }





    public getMapColor(mapa: FullMapModel): FullMapModel {
        return this.getParcelasFormFacade().withMapColor(mapa, this.env.customMapColorsList);
    }

    public saveNewOption(): void {
        this.getParcelasFormFacade().saveComunidadRegantes({
            comunidadForm: this.comunidadForm,
            endpoint: `${this.env.serverURL}/ws/index.php?p1=generic&p2=comunidades_regantes`,
            http: this.http,
            reloadRequest: this.analisisApi.comunidadesRegantes.GET,
            comunidadesRegantesDropdown: this.form.lists.comunidadesRegantes,
            closeDialog: () => {
                this.form.openDialog = false;
            },
        });
    }



    private getParcelasFormFacade(): ParcelasFormFacade {
        this.parcelasFormFacade ??= new ParcelasFormFacade({
            dataSourceFactory: this.dropdownDataSourceFactory,
            getFormBuilderRef: () => this.formBuilderRef,
            getFormModel: () => this.form?.model,
            getFallbackModel: () => this.model,
            getLegacyCultivoSelected: () => this.form?.lists?.cultivos
                ? getDropdownSelectedSingle(this.form.lists.cultivos)
                : null,
            getLegacyVariedadSelected: () => this.form?.lists?.variedades
                ? getDropdownSelectedSingle(this.form.lists.variedades)
                : null,
            getFormType: () => this.getType(),
            getUserId: () => StorageManager.getUser().id,
            getClientId: () => StorageManager.getClient()?.id ?? '',
            refreshReactiveDropdownMappings: () => this.refreshReactiveDropdownMappings(),
        });

        return this.parcelasFormFacade;
    }

    /**
     * Applies the REA finca selection after dropdown data has been loaded.
     */
    private applyReaReviewFincaSelection(): void {
        const fincaDropdown = this.form.lists.fincas as DropdownData<unknown>;
        const control = this.formBuilderRef?.model?.get('id_finca');

        this.getParcelasFormFacade().synchronizeReaFincaSelection({
            pendingFincaId: this.pendingReaReviewFincaId,
            fincaDropdown,
            hasCurrentMap: Boolean(this.form.model.mapa?.[0]),
            applyModelPatch: (patch) => {
                Object.assign(this.model, patch);
            },
            applyFormModelPatch: (patch) => {
                Object.assign(this.form.model, patch);
            },
            setSelectedFinca: (selectedFinca) => {
                setDropdownSelected(fincaDropdown, selectedFinca);
            },
            patchFincaControl: (fincaId) => {
                control?.patchValue(fincaId, { emitEvent: false });
            },
            markFincaControlPristine: () => {
                control?.markAsPristine();
            },
            applyMapPatch: (patch) => {
                Object.assign(this.form.model.mapa?.[0] ?? {}, patch);
            },
            updateReactiveForm: () => {
                this.formBuilderRef?.updateForm(this.form.model, false);
            },
        });
    }

    private toStringId(value: unknown): string {
        return this.dropdownDataSourceFactory.toStringId(value);
    }


    private configureDeclarativeDropdownSources(): void {
        configureParcelasDeclarativeDropdowns({
            form: this.form,
            formType: this.getType(),
            env: this.env,
            dataSources: this.dropdownDataSourceFactory.createDataSources({
                env: this.env,
                addDefaultAplicador: (row) => this.addDefaultSequiadorAplicador(row),
            }),
        });
    }
    private toRecord(value: unknown): Record<string, unknown> {
        return this.dropdownDataSourceFactory.toRecord(value);
    }

    private addDefaultSequiadorAplicador(row: unknown): void {
        const rowRecord = this.toRecord(row);

        if (this.toStringId(rowRecord['nombre']) !== 'TONI') {
            return;
        }

        const selectedList = getDropdownSelectedArray<MantenimientoModel>(this.form.lists.aplicadores);
        const rowId = this.toStringId(rowRecord['id']);
        const alreadySelected = selectedList.some((item) => this.toStringId(this.toRecord(item)['id']) === rowId);

        if (!alreadySelected) {
            selectedList.push(row as MantenimientoModel);
            setDropdownSelectedFromArray(
                this.form.lists.aplicadores,
                selectedList,
                true
            );
        }
    }

    private transformCatalogPreviousData(previousData: ParcelasModel): ParcelasModel {
        return ParcelasCatalogHydrator.transformPreviousData({
            previousData,
            env: this.env,
            formType: this.getType(),
            cultivosDropdown: this.form.lists.cultivos as DropdownData<unknown>,
            variedadesDropdown: this.form.lists.variedades as DropdownData<unknown>,
            sectoresDropdown: this.form.lists.sectores as DropdownData<unknown>,
            sistemasRiegoDropdown: this.form.lists.sistemasRiego as DropdownData<unknown>,
            dataSourceFactory: this.dropdownDataSourceFactory,
        });
    }
    private initFormData(): Promise<boolean> {
        return ParcelasFormDataLoader.load({
            form: this.form,
            formType: this.getType(),
            env: this.env,
            endpoints: {
                portainjertosGET: this.siexApi.portainjertosGET,
                sistemasRiegoGET: this.siexApi.sistemasRiegoGET,
                comunidadesRegantesGET: this.analisisApi.comunidadesRegantes.GET,
                origenesAguaRiegoGET: this.siexApi.origenesAguaRiegoGET,
                fincasGET: this.fincasApi.fincasGET,
                sectoresGET: this.fincasApi.sectoresGET,
                compradoresGET: this.ventasApi.compradoresGET,
                usuariosGET: this.usuariosAPI.usuariosGET,
                trabajadoresGET: this.trabajadoresApi.trabajadoresGET,
                cultivosGET: this.formApi.cultivosGET,
                variedadesGET: this.formApi.variedadesGET,
            },
            addDefaultSequiadorAplicador: (row) => this.addDefaultSequiadorAplicador(row),
            setLoadingData: (loading) => {
                this.loadingData = loading;
            },
        }).then(() => {
            this.applyReaReviewFincaSelection();
            this.refreshReactiveDropdownMappings();

            return true;
        });
    }


    private refreshReactiveDropdownMappings(): void {
        this.externalDropdownsLoaded = true;
        this.formBuilderRef?.finalizeExternalDropdowns();
        this.formBuilderRef?.refreshExternalDropdownMappings();
    }


    private createVariedadVarios(
        request: ParcelasVariedadVariosCreateRequest
    ): Promise<readonly Partial<VisitasVariedadMesModel>[] | null | undefined> {
        return this.visitasVariedadMesApi.visitasVariedadMes.POST.toPromise(request as never) as Promise<
            readonly Partial<VisitasVariedadMesModel>[] | null | undefined
        >;
    }

    private expandFormRequest(): void {
        this.getParcelasFormFacade().registerSendBefore({
            formRequest: this.formRequest,
            env: this.env,
            formFieldsDatosParcela: this.form.formFieldsDatosParcela.fields,
            variedadesDropdown: this.form.lists.variedades as DropdownData<VisitasVariedadMesModel>,
            createVariedad: (request) => this.createVariedadVarios(request),
            applyLegacyModelPatch: (patch) => {
                if (patch.id_variedad !== undefined) {
                    this.model.id_variedad = patch.id_variedad;
                }
            },
            markVariedadVariosCreated: () => {
                this.variedadVariosCreated = true;
            },
            applyFormModelPatch: (patch) => {
                this.form.model = {
                    ...this.form.model,
                    ...patch,
                };
                this.formBuilderRef.updateForm(this.form.model, false);
            },
            logError: (message) => {
                console.log(message);
            },
        });
    }
}
